<div class="text-start px-1.5 2xl:py-2 py-1 border-t border-[#f4f4f4ad]" [ngClass]="classes">
    <p *ngIf="groupTitle() && !minimized()" class="text-white opacity-60 2xl:text-[0.8rem] text-[0.7rem] px-3.5 py-1">{{ groupTitle() | translate }}</p>

    <app-navigation-item *ngFor="let item of items()" [item]="item" [minimized]="minimized()" [onActiveLink]="onActive"></app-navigation-item>
</div>
